import { memo } from 'react';
import { AlertBanner } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { UserX } from 'lucide-react';

/** Banner of a removed member: no access, roles or groups, cannot sign in. */
const RemovedBanner = ({ name }) => {
  const { t } = useTranslation('people-access');
  return (
    <AlertBanner tone="info" icon={UserX} title={t('memberDetail.banner.removed.title')}>
      {t('memberDetail.banner.removed.message', { name })}
    </AlertBanner>
  );
};

export default memo(RemovedBanner);
